import { Link } from "react-router-dom";
import { lineup2026 } from "../data/lineup";
import { festival } from "../data/festival";
import { useTickets } from "../context/TicketsContext";
import Page, { PageHero } from "../components/Page";
import SubNav from "../components/SubNav";
import Button from "../components/Button";
import { Mushroom, Hummingbird, SnakeStripe } from "../components/Doodles";
import { IconArrow } from "../components/icons";
import styles from "./Lineup.module.css";

const subNav = [
  { label: "2026 Lineup", path: "/lineup", end: true },
  { label: "Previous Lineups", path: "/lineup/previous" },
];

export default function Lineup() {
  const { open: openTickets } = useTickets();
  return (
    <>
      <PageHero
        eyebrow={festival.dates}
        title="The 2026 Lineup"
        lede="Seventeen acts, three days of music, one Jerry Garcia tribute. Bluegrass, jamgrass, electro-folk, funk, reggae — sit in the grass and find the next band you'll spend a year listening to."
        image="/photos/festival-1.jpg"
      />
      <SubNav items={subNav} />

      {/* THE POSTER — block-quote-style centerpiece. Snake stripes
          frame it; doodles drift in the corners. */}
      <section className={styles.posterBlock}>
        <Mushroom className={styles.doodleA} size={56} color="#f06c33" spotColor="#f7f0e3" />
        <Mushroom className={styles.doodleB} size={44} color="#f3b740" spotColor="#0d2a26" />
        <Hummingbird className={styles.doodleC} size={120} color="#f3b740" />

        <div className={styles.posterInner}>
          <a
            href="/posters/rotr-2026.png"
            target="_blank"
            rel="noopener"
            className={styles.posterLink}
            aria-label="Open full-size 2026 poster"
          >
            <img
              src="/posters/rotr-2026.png"
              alt="Rhythms on the Rio 2026 poster"
              loading="eager"
            />
          </a>
          <div className={styles.posterCopy}>
            <span className={styles.posterEyebrow}>The Poster</span>
            <h2 className={styles.posterTitle}>Print it. Frame it. Bring the original home.</h2>
            <p>
              Limited-run prints will be available at the festival merch booth — get
              there early. Click the poster to open the full-resolution art.
            </p>
            <ul className={styles.factsList}>
              <li><span className={styles.tag}>×3</span> Sets of Leftover Salmon (incl. Jerry Garcia tribute)</li>
              <li><span className={styles.tag}>×2</span> Sets of the Infamous Stringdusters</li>
              <li><span className={styles.tagDark}>Late Night</span> Magoo · Sqwerv</li>
            </ul>
            <div className={styles.cta}>
              <Button onClick={openTickets} variant="primary" size="lg">
                Buy Tickets
              </Button>
              <Link to="/about/venue" className={styles.ctaLink}>
                Venue & camping info <IconArrow />
              </Link>
            </div>
          </div>
        </div>
      </section>

      <SnakeStripe height={28} color="#f06c33" color2="#f3b740" />

      <Page>
        <div className={styles.grid}>
          {lineup2026.map((a, i) => (
            <article
              key={a.id}
              className={[styles.card, a.headliner ? styles.headliner : ""].join(" ")}
            >
              <div className={styles.imgWrap}>
                <img src={a.photo} alt={a.name} loading={i < 4 ? "eager" : "lazy"} />
                <div className={styles.cardBadges}>
                  {a.headliner && <span className={styles.headlinerTag}>Headliner</span>}
                  {a.sets > 1 && <span className={styles.setsTag}>×{a.sets} Sets</span>}
                  {a.tribute && <span className={styles.tributeTag}>{a.tribute}</span>}
                  {a.lateNight && <span className={styles.lateTag}>Late Night</span>}
                </div>
              </div>
              <div className={styles.body}>
                <h2 className={styles.name}>{a.name}</h2>
                <p className={styles.blurb}>{a.blurb}</p>
              </div>
            </article>
          ))}
        </div>
      </Page>
    </>
  );
}
